import React from 'react'

import { Link } from 'react-router-dom'

import { AiOutlineRight } from 'react-icons/ai'
import { RiGitCommitLine } from 'react-icons/ri'

import MenuItemSubMenu from './MenuItemSubMenu'

const clickLink = () => {
  const nodoBody = document.body
  nodoBody.classList.add('sidebar-hide')
}

const MenuItem = ({ name, page, subMenuInfo }) => {
  const menuHtml = React.useMemo(() => {
    const construirRoot = __array => {
      const salida = []

      for (let i = 0; i < __array.length; i++) {
        const element = __array[i]

        if (!element.submenu || element.submenu.length === 0) {
          salida.push(
            <li>
              <Link to={`/${element.page}`} onClick={clickLink}>
                <RiGitCommitLine />
                <span>{element.title}</span>
              </Link>
            </li>
          )
        } else {
          salida.push(<MenuItemSubMenu name={element.title} subMenuInfo={element.submenu} />)
        }
      }

      return salida
    }

    const menuConstruido = construirRoot(subMenuInfo || [])

    return menuConstruido || []
  }, [subMenuInfo])

  const clickMenuItem = e => {
    e.preventDefault()

    const isOpen = e.currentTarget.parentNode.classList.contains('open')

    const nodosItemsMenu = document.getElementsByClassName('sidebar-menu__slide')

    for (let o = 0; o < nodosItemsMenu.length; o++) {
      const ele = nodosItemsMenu[o]
      ele.classList.remove('open')
    }

    if (!isOpen) {
      e.currentTarget.parentNode.classList.toggle('open')
    }
  }

  return (
    <li className='sidebar-menu__slide'>
      {page ? (
        <Link className='sidebar-menu__item' to={`/${page}`} onClick={clickLink}>
          <span>{name}</span>
        </Link>
      ) : (
        <a href='#!' className='sidebar-menu__item' onClick={clickMenuItem}>
          <span>{name}</span>
          {subMenuInfo && <AiOutlineRight />}
        </a>
      )}
      {subMenuInfo && <ul className='sidebar-menu__itemmenu'>{menuHtml}</ul>}
    </li>
  )
}

export default React.memo(MenuItem)
